import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';

export const updateRetryCount = (count) => (dispatch, getState) => {
    const { serverData: { appPendData = {} } = {} } = getState();
    dispatch(setServerData({
        appPendData: {
            ...appPendData,
            finalSubmitRetryCount: count,
            finalUvsResponse: {},
            documentVerificationDetails: {}
        }
    }));
};
